export const INITIAL_ES_PROGRAM = {
	programName: '',
	supportSource: '',
	applicableIndustry: '',
	country: '',
	supports: {
		inventoryGuidance: false,
		technicalUpgradeAndInnovation: false,
		systemTechnologyImplementation: false,
		systemEquipmentOptimization: false,
		equipmentProcurementAndReplacement: false,
	},
};
